import Vue from "vue";
import VueRouter from "vue-router";
import error from '../views/error.vue'

Vue.use(VueRouter);

const routes = [
    // 登录
    {
        path: "/login",
        component: () =>
            import ("@/views/login.vue"),
        name: "login",
    },



    {
        path: "/home",
        component: () =>
            import ("@/views/home.vue"),
        name: "home",
        redirect: '/home/zhu',
        children: [
            // 域管理
            {
                path: '/home/domain_manage/domain_list',
                component: () =>
                    import ("@/components/domain_manage/domain_list.vue"),
                name: 'domain_list',
                meta: {
                    lie: [{ name: '域列表' }],

                    name: [
                        { name: '域管理' },
                        { name: '域列表' },
                    ],
                    lie1: [{ name: 'Domain List', id: '2' }],
                    name1: [
                        { name: 'Domain Manage' },
                        { name: 'Domain List' },
                    ],
                }


            },
            {
                path: '/home/domain_manage/change_domainName',
                component: () =>
                    import ("@/components/domain_manage/change_domainName.vue"),
                name: 'change_domainName',
                meta: {
                    lie: [{ name: '更改域名' }],

                    name: [
                        { name: '域管理' },
                        { name: '更改域名' },
                    ],
                    lie1: [{ name: 'Change DomainName', id: '2' }],
                    name1: [
                        { name: 'Domain Manage' },
                        { name: 'Change DomainName' },
                    ],
                }


            },
            {
                path: '/home/domain_manage/change_domainAgent',
                component: () =>
                    import ("@/components/domain_manage/change_domainAgent.vue"),
                name: 'change_domainAgent',
                meta: {
                    lie: [{ name: '更改所属代理' }],

                    name: [
                        { name: '域管理' },
                        { name: '更改所属代理' },
                    ],
                    lie1: [{ name: 'Change DomainAgent', id: '2' }],
                    name1: [
                        { name: 'Domain Manage' },
                        { name: 'Change DomainAgent' },
                    ],
                }


            },
            {
                path: '/home/domain_manage/set_mail_move',
                component: () =>
                    import ("@/components/domain_manage/set_mail_move.vue"),
                name: 'set_mail_move',
                meta: {
                    lie: [{ name: '设置邮件搬家' }],

                    name: [
                        { name: '域管理' },
                        { name: '设置邮件搬家' },
                    ],
                    lie1: [{ name: 'Set MailMove', id: '2' }],
                    name1: [
                        { name: 'Domain Manage' },
                        { name: 'Set MailMove' },
                    ],
                }


            },
            // 域管理 end
            // 域别名管理
            {
                path: '/home/domain_alias/alias_list',
                component: () =>
                    import ("@/components/domain_alias/alias_list.vue"),
                name: 'alias_list',
                meta: {
                    lie: [{ name: '域别名列表' }],

                    name: [
                        { name: '域别名管理' },
                        { name: '域别名列表' },
                    ],
                    lie1: [{ name: 'Alias List', id: '2' }],
                    name1: [
                        { name: 'Domain Alias' },
                        { name: 'Alias List' },
                    ],
                }


            },
            // 域别名管理 end
            // 代理商管理
            {
                path: '/home/agent/agent_list',
                component: () =>
                    import ("@/components/agent/agent_list.vue"),
                name: 'agent_list',
                meta: {
                    lie: [{ name: '代理商列表' }],

                    name: [
                        { name: '代理商管理' },
                        { name: '代理商列表' },
                    ],
                    lie1: [{ name: 'Agent List', id: '2' }],
                    name1: [
                        { name: 'Agent' },
                        { name: 'Agent List' },
                    ],
                }


            },
            {
                path: '/home/agent/create_agent',
                component: () =>
                    import ("@/components/agent/create_agent.vue"),
                name: 'create_agent',
                meta: {
                    lie: [{ name: '增加代理商' }],

                    name: [
                        { name: '代理商管理' },
                        { name: '增加代理商' },
                    ],
                    lie1: [{ name: 'Create Agent', id: '2' }],
                    name1: [
                        { name: 'Agent' },
                        { name: 'Create Agent' },
                    ],
                }


            },
            // 代理商管理 end 

            // 角色管理
            {
                path: '/home/role/role_list',
                component: () =>
                    import ("@/components/role/role_list.vue"),
                name: 'role_list',
                meta: {
                    lie: [{ name: '角色列表' }],

                    name: [
                        { name: '角色管理' },
                        { name: '角色列表' },
                    ],
                    lie1: [{ name: 'Role List', id: '2' }],
                    name1: [
                        { name: 'Role' },
                        { name: 'Role List' },
                    ],
                }


            },
            {
                path: '/home/system/role_list_new',
                component: () =>
                    import ("@/components/system/role_list_new.vue"),
                name: 'role_list_new',
                meta: {
                    lie: [{ name: '角色列表' }],

                    name: [
                        { name: '角色管理' },
                        { name: '角色列表' },
                    ],
                    lie1: [{ name: 'Role List', id: '2' }],
                    name1: [
                        { name: 'Role' },
                        { name: 'Role List' },
                    ],
                }


            },
            {
                path: '/home/role/set_boss',
                component: () =>
                    import ("@/components/role/set_boss.vue"),
                name: 'set_boss',
                meta: {
                    lie: [{ name: '设置老板' }],

                    name: [
                        { name: '角色管理' },
                        { name: '设置老板' },
                    ],
                    lie1: [{ name: 'Set Boss', id: '2' }],
                    name1: [
                        { name: 'Role' },
                        { name: 'Set Boss' },
                    ],
                }


            },
            // 角色管理  end

            // 定制管理
            {
                path: '/home/customize/customize_ui',
                component: () =>
                    import ("@/components/customize/customize_ui.vue"),
                name: 'customize_ui',
                meta: {
                    lie: [{ name: '界面定制' }],

                    name: [
                        { name: '定制管理' },
                        { name: '界面定制' },
                    ],
                    lie1: [{ name: 'Mail Limit', id: '2' }],
                    name1: [
                        { name: 'Customize Manage' },
                        { name: 'Mail Limit' },
                    ],
                }


            },
            {
                path: '/home/customize/advertising',
                component: () =>
                    import ("@/components/customize/advertising.vue"),
                name: 'advertising',
                meta: {
                    lie: [{ name: '广告定制' }],

                    name: [
                        { name: '定制管理' },
                        { name: '广告定制' },
                    ],
                    lie1: [{ name: 'Advertising', id: '2' }],
                    name1: [
                        { name: 'Customize Manage' },
                        { name: 'Advertising' },
                    ],
                }


            },
            // 定制管理 end 
            // 邮件管理
            {
                path: '/home/mail_manage/mail_limit',
                component: () =>
                    import ("@/components/mail_manage/mail_limit.vue"),
                name: 'mail_limit',
                meta: {
                    lie: [{ name: '邮件限制列表' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '邮件限制列表' },
                    ],
                    lie1: [{ name: 'Mail Limit', id: '2' }],
                    name1: [
                        { name: 'Mail Manage' },
                        { name: 'Mail Limit' },
                    ],
                }


            },
            {
                path: '/home/mail_manage/group_sending',
                component: () =>
                    import ("@/components/mail_manage/group_sending.vue"),
                name: 'group_sending',
                meta: {
                    lie: [{ name: '群发邮件' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '群发邮件' },
                    ],
                    lie1: [{ name: 'Group Sending', id: '2' }],
                    name1: [
                        { name: 'Mail Manage' },
                        { name: 'Group Sending' },
                    ],
                }


            },
            {
                path: '/home/mail_manage/mail_list',
                component: () =>
                    import ("@/components/mail_manage/mail_list.vue"),
                name: 'mail_list',
                meta: {
                    lie: [{ name: '邮件列表' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '邮件列表' },
                    ],
                    lie1: [{ name: 'Mail List', id: '2' }],
                    name1: [
                        { name: 'Mail Manage' },
                        { name: 'Mail List' },
                    ],
                }


            },
            {
                path: '/home/mail_manage/alias_list',
                component: () =>
                    import ("@/components/mail_manage/alias_list.vue"),
                name: 'alias_list',
                meta: {
                    lie: [{ name: '别名列表' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '别名列表' },
                    ],
                    lie1: [{ name: 'Alias List', id: '2' }],
                    name1: [
                        { name: 'Mail Manage' },
                        { name: 'Alias List' },
                    ],
                }


            },
            {
                path: '/home/mail_manage/monitor_list',
                component: () =>
                    import ("@/components/mail_manage/monitor_list.vue"),
                name: 'monitor_list',
                meta: {
                    lie: [{ name: '监控列表' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '监控列表' },
                    ],
                    lie1: [{ name: 'Monitor List', id: '2' }],
                    name1: [
                        { name: 'Mail Manage' },
                        { name: 'Monitor List' },
                    ],
                }


            },
            //  邮件管理 end
            // 用户管理
            {
                path: '/home/usermanage/bulk_import',
                component: () =>
                    import ("@/components/usermanage/bulk_import.vue"),
                name: 'bulk_import',
                meta: {
                    lie: [{ name: '批量操作' }],

                    name: [
                        { name: '用户管理' },
                        { name: '批量操作' },
                    ],
                    lie1: [{ name: 'Bulk Action', id: '2' }],
                    name1: [
                        { name: 'User Manage' },
                        { name: 'Bulk Action' },
                    ],
                }


            },
            {
                path: '/home/usermanage/create_user',
                component: () =>
                    import ("@/components/usermanage/create_user.vue"),
                name: 'create_user',
                meta: {
                    lie: [{ name: '创建用户' }],

                    name: [
                        { name: '用户管理' },
                        { name: '创建用户' },
                    ],
                    lie1: [{ name: 'Create User', id: '2' }],
                    name1: [
                        { name: 'User Manage' },
                        { name: 'Create User' },
                    ],
                }


            },
            {
                path: '/home/usermanage/user_list',
                component: () =>
                    import ("@/components/usermanage/user_list.vue"),
                name: 'user_list',
                meta: {
                    lie: [{ name: '用户列表' }],

                    name: [
                        { name: '用户管理' },
                        { name: '用户列表' },
                    ],
                    lie1: [{ name: 'User List', id: '2' }],
                    name1: [
                        { name: 'User Manage' },
                        { name: 'User List' },
                    ],
                }


            },
            // 用户管理end
            // 部门管理
            {
                path: '/home/list_depart',
                component: () =>
                    import ("@/components/depart_manage/list_depart.vue"),
                name: 'list_depart',
                meta: {
                    lie: [{ name: '部门列表' }],

                    name: [
                        { name: '部门管理' },
                        { name: '部门列表' },
                    ],
                    lie1: [{ name: 'List Depart', id: '2' }],
                    name1: [
                        { name: 'Depart Manage' },
                        { name: 'List Depart' },
                    ],
                }


            },
            {
                path: '/home/depart_structure',
                component: () =>
                    import ("@/components/depart_manage/depart_structure.vue"),
                name: 'depart_structure',
                meta: {
                    lie: [{ name: '部门结构' }],

                    name: [
                        { name: '部门管理' },
                        { name: '部门结构' },
                    ],
                    lie1: [{ name: 'Depart Structure', id: '2' }],
                    name1: [
                        { name: 'Depart Manage' },
                        { name: 'Depart Structure' },
                    ],
                }


            },
            // 部门管理end
            // 公告管理
            {
                path: '/home/notice_list',
                component: () =>
                    import ("@/components/notice/notice_list.vue"),
                name: 'notice_list',
                meta: {
                    lie: [{ name: '公告列表' }],

                    name: [
                        { name: '公告管理' },
                        { name: '公告列表' },
                    ],
                    lie1: [{ name: 'Notice List', id: '2' }],
                    name1: [
                        { name: 'Notice' },
                        { name: 'Notice List' },
                    ],
                }


            },
            // 公告管理end
            // 超连接
            {
                path: '/home/hyperlink/hy_basic',
                component: () =>
                    import ("@/components/hyperlink/hy_basic.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '基本配置' }],

                    name: [
                        { name: '超链接隔离' },
                        { name: '基本配置' },
                    ],
                    lie1: [{ name: 'basic', id: '2' }],
                    name1: [
                        { name: 'Hyperlink Isolation' },
                        { name: 'basic' },
                    ],
                }

            },
            {
                path: '/home/hyperlink/hy_to_white',
                component: () =>
                    import ("@/components/hyperlink/hy_to_white.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '转化白名单' }],

                    name: [
                        { name: '超链接隔离' },
                        { name: '转化白名单' },
                    ],
                    lie1: [{ name: 'Convert Whitelist', id: '2' }],
                    name1: [
                        { name: 'Hyperlink Isolation' },
                        { name: 'Convert Whitelist' },
                    ],
                }

            },
            {
                path: '/home/hyperlink/hy_policy',
                component: () =>
                    import ("@/components/hyperlink/hy_policy.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '转化策略' }],

                    name: [
                        { name: '超链接隔离' },
                        { name: '转化策略' },
                    ],
                    lie1: [{ name: 'Convert Policy', id: '2' }],
                    name1: [
                        { name: 'Hyperlink Isolation' },
                        { name: 'Convert Policy' },
                    ],
                }

            },
            // 超连接 end
            {
                path: '/home/error_e',
                component: () =>
                    import ("@/views/error_e.vue"),
                name: 'error_e',



            },
            {
                path: '/home/zhu',
                component: () =>
                    import ("@/views/zhu.vue"),
                name: 'list_admin',

                meta: {
                    title: '标题',
                    lie: [{ name: '首页' }],

                    name: [
                        { name: '首页' },
                        { name: '首页' },
                    ],
                    lie1: [{ name: 'Home', id: '2' }],
                    name1: [
                        { name: 'Home' },
                        { name: 'Home' },
                    ],
                }

            },
            {
                path: "/home/kongbai",
                component: () =>
                    import ("@/views/kongbai.vue"),
                name: "kongbai",
            },
            //  客户服务
            {
                path: '/home/system/customer_records',
                component: () =>
                    import ("@/components/system/customer_records.vue"),
                name: 'customer_records',
                meta: {
                    lie: [{ name: '客户服务' }],

                    name: [
                        { name: '系统管理' },
                        { name: '客户服务' },
                    ],
                    lie1: [{ name: 'User Settings', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'User Settings' },
                    ],
                }


            },
            //  客户服务 end
            // 系统管理
            {
                path: '/home/system/menu',
                component: () =>
                    import ("@/components/system/menu.vue"),
                name: 'list_admin',
                meta: {
                    lie: [{ name: '系统信息' }],

                    name: [
                        { name: '系统管理' },
                        { name: '系统信息' },
                    ],
                    lie1: [{ name: 'System Info', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'System Info' },
                    ],
                }
            },
            // 用户管理
            {
                path: '/home/system/user_list',
                component: () =>
                    import ("@/components/system/user_list.vue"),
                name: 'list_admin',
                meta: {
                    lie: [{ name: '用户管理' }],

                    name: [
                        { name: '系统管理' },
                        { name: '用户管理' },
                    ],
                    lie1: [{ name: 'User Control', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'User Control' },
                    ],
                }
            },
            {
                path: '/home/system/mode_switch1',
                component: () =>
                    import ("@/components/system/mode_switch1.vue"),
                name: 'mode_switch1',
                meta: {
                    lie: [{ name: '模式切换' }],

                    name: [
                        { name: '系统管理' },
                        { name: '模式切换' },
                    ],
                    lie1: [{ name: 'Mode Switch', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'Mode Switch' },
                    ],
                }


            },
            {
                path: '/home/system/mode_switch',
                component: () =>
                    import ("@/components/system/mode_switch.vue"),
                name: 'mode_switch',
                meta: {
                    lie: [{ name: '管理模式' }],

                    name: [
                        { name: '系统管理' },
                        { name: '管理模式' },
                    ],
                    lie1: [{ name: 'Mode Switch', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'Mode Switch' },
                    ],
                }


            },
            {
                path: '/home/system/role_list',
                component: () =>
                    import ("@/components/system/role_list.vue"),
                name: 'role_list',
                meta: {
                    lie: [{ name: '角色列表' }],

                    name: [
                        { name: '系统管理' },
                        { name: '角色列表' },
                    ],
                    lie1: [{ name: 'Role List', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'Role List' },
                    ],
                }


            },
            {
                path: '/home/system/user_settings',
                component: () =>
                    import ("@/components/system/user_settings.vue"),
                name: 'user_settings',
                meta: {
                    lie: [{ name: '用户设置' }],

                    name: [
                        { name: '系统管理' },
                        { name: '用户设置' },
                    ],
                    lie1: [{ name: 'User Settings', id: '2' }],
                    name1: [
                        { name: 'System Condition' },
                        { name: 'User Settings' },
                    ],
                }


            },
            // 系统管理  end

            // 管理员列表
            // list
            {
                path: '/home/admins/list',
                component: () =>
                    import ("@/components/admins/list.vue"),
                name: 'list_admin',
                meta: [
                    { name: '管理员设置' },


                ],

            },
            // add
            {
                path: '/home/admins/add',
                component: () =>
                    import ("@/components/admins/add.vue"),
                name: 'com_gate_g',

            },
            // 正常邮件  Normal Mail
            //精查
            {
                path: '/home/management/listOne/:rec_id',
                component: () =>
                    import ("@/components/management/listOne.vue"),
                name: 'guiDangListOne1',


            },
            // 不是精查
            {
                path: '/home/management/listOne1/:rec_id',
                component: () =>
                    import ("@/components/management/listOne1.vue"),
                name: 'glistOne',


            },
            {
                path: '/home/management/mailingList1',
                component: () =>
                    import ("@/components/management/mailingList1.vue"),
                name: 'mailingList1',

                meta: {
                    lie: [{ name: '精查正常邮件列表' }],

                    name: [
                        { name: '正常邮件' },
                        { name: '精查正常邮件列表' },
                    ],
                    lie1: [{ name: 'ELKNormal List', id: '2' }],
                    name1: [
                        { name: 'Normal Mail' },
                        { name: 'ELKNormal List' },
                    ],
                }
            },
            {
                path: '/home/management/send_mail',
                component: () =>
                    import ("@/components/management/send_mail.vue"),
                name: 'send_mail',

                meta: {
                    lie: [{ name: '发送邮件列表' }],

                    name: [
                        { name: '正常邮件' },
                        { name: '发送邮件列表' },
                    ],
                    lie1: [{ name: 'Send_mail List', id: '2' }],
                    name1: [
                        { name: 'Normal Mail' },
                        { name: 'Send_mail List' },
                    ],
                }
            },
            {
                path: '/home/management/receive_mail',
                component: () =>
                    import ("@/components/management/receive_mail.vue"),
                name: 'receive_mail',

                meta: {
                    lie: [{ name: '接收邮件列表' }],

                    name: [
                        { name: '正常邮件' },
                        { name: '接收邮件列表' },
                    ],
                    lie1: [{ name: 'Receive_mail  List', id: '2' }],
                    name1: [
                        { name: 'Normal Mail' },
                        { name: 'Receive_mail  List' },
                    ],
                }
            },
            {
                path: '/home/management/mailingList',
                component: () =>
                    import ("@/components/management/mailingList.vue"),
                name: 'mailingList',

                meta: {
                    lie: [{ name: '正常邮件列表' }],

                    name: [
                        { name: '正常邮件' },
                        { name: '正常邮件列表' },
                    ],
                    lie1: [{ name: 'Normal List', id: '2' }],
                    name1: [
                        { name: 'Normal Mail' },
                        { name: 'Normal List' },
                    ],
                }
            },
            {
                path: '/home/management/account',
                component: () =>
                    import ("@/components/management/account.vue"),
                name: 'cfg_auth',
                meta: [
                    { name: '正常邮件' },
                    { name: '按账号查询' },
                ],
            },
            {
                path: '/home/management/search',
                component: () =>
                    import ("@/components/management/search.vue"),
                name: 'cfg_auth',
                meta: [
                    { name: '正常邮件' },
                    { name: '归档搜索' },
                ],
            },
            {
                path: '/home/management/appoint',
                component: () =>
                    import ("@/components/management/appoint.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '委派列表' }],

                    name: [
                        { name: '正常邮件' },
                        { name: '委派列表' },
                    ],
                    lie1: [{ name: 'Delegate list', id: '2' }],
                    name1: [
                        { name: 'Normal Mail' },
                        { name: 'Delegate list' },
                    ],
                }
            },
            // 日志管理
            {
                path: '/home/log/filtration1',
                component: () =>
                    import ("@/components/log/filtration1.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '精查实时过滤日志' }],

                    name: [
                        { name: '日志管理' },
                        { name: '精查实时过滤日志' },
                    ],
                    lie1: [{ name: 'ELKFilter Log', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'ELKFilter Log' },
                    ],
                }
            },
            {
                path: '/home/log/filtration',
                component: () =>
                    import ("@/components/log/filtration.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '实时过滤日志' }],

                    name: [
                        { name: '日志管理' },
                        { name: '实时过滤日志' },
                    ],
                    lie1: [{ name: 'Filter Log', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Filter Log' },
                    ],
                }
            },
            {
                path: '/home/log/send1',
                component: () =>
                    import ("@/components/log/send1.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '精查实时投递日志' }],

                    name: [
                        { name: '日志管理' },
                        { name: '精查实时投递日志' },
                    ],
                    lie1: [{ name: 'ELKMessage Queue', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'ELKMessage Queue' },
                    ],
                }
            },
            {
                path: '/home/log/routing',
                component: () =>
                    import ("@/components/log/routing.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '精查详细路由日志' }],

                    name: [
                        { name: '日志管理' },
                        { name: '精查详细路由日志' },
                    ],
                    lie1: [{ name: 'ELKQueue Detail', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'ELKQueue Detail' },
                    ],
                }
            },
            {
                path: '/home/log/send',
                component: () =>
                    import ("@/components/log/send.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '实时投递日志' }],

                    name: [
                        { name: '日志管理' },
                        { name: '实时投递日志' },
                    ],
                    lie1: [{ name: 'Message Queue', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Message Queue' },
                    ],
                }
            },
            {
                path: '/home/log/queue',
                component: () =>
                    import ("@/components/log/queue.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '当前队列' }],

                    name: [
                        { name: '日志管理' },
                        { name: '当前队列' },
                    ],
                    lie1: [{ name: 'Cur Message Queue', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Cur Message Queue' },
                    ],
                }
            },
            {
                path: '/home/log/connect',
                component: () =>
                    import ("@/components/log/connect.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '当前SMTP连接' }],

                    name: [
                        { name: '日志管理' },
                        { name: '当前SMTP连接' },
                    ],
                    lie1: [{ name: 'Cur Smtp Connec', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Cur Smtp Connec' },
                    ],
                }
            },
            {
                path: '/home/log/abnormalAccount',
                component: () =>
                    import ("@/components/log/abnormalAccount.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '异常账号' }],

                    name: [
                        { name: '日志管理' },
                        { name: '异常账号' },
                    ],
                    lie1: [{ name: 'Abuse Email', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Abuse Email' },
                    ],
                }
            },
            {
                path: '/home/log/remoteControl',
                component: () =>
                    import ("@/components/log/remoteControl.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '远程控制' }],

                    name: [
                        { name: '日志管理' },
                        { name: '远程控制' },
                    ],
                    lie1: [{ name: 'Spam Control Cmd', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Spam Control Cmd' },
                    ],
                }
            },
            {
                path: '/home/log/adminLog',
                component: () =>
                    import ("@/components/log/adminLog.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '管理日志' }],

                    name: [
                        { name: '日志管理' },
                        { name: '管理日志' },
                    ],
                    lie1: [{ name: 'Manage Log', id: '2' }],
                    name1: [
                        { name: 'Log Manager' },
                        { name: 'Manage Log' },
                    ],
                }
            },
            // 数据统计排行
            {
                path: '/home/database/data',
                component: () =>
                    import ("@/components/database/data.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '数据统计' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '数据统计' },
                    ],
                    lie1: [{ name: 'Data Statistics', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Data Statistics' },
                    ],
                }
            },
            {
                path: '/home/database/statement',
                component: () =>
                    import ("@/components/database/statement.vue"),
                name: 'cfg_auth',
                meta: [
                    { name: '数据统计排行' },
                    { name: '统计报表' },
                ],
            },
            {
                path: '/home/database/localUserSend',
                component: () =>
                    import ("@/components/database/localUserSend.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '本地用户发信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '本地用户发信' },
                    ],
                    lie1: [{ name: 'local Sendmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'local Sendmsg' },
                    ],
                }
            },
            {
                path: '/home/database/localUserAddress',
                component: () =>
                    import ("@/components/database/localUserAddress.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '本地用户收信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '本地用户收信' },
                    ],
                    lie1: [{ name: 'local Rcvmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'local Rcvmsg' },
                    ],
                }
            },
            {
                path: '/home/database/externalUserSend',
                component: () =>
                    import ("@/components/database/externalUserSend.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '外部用户发信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '外部用户发信' },
                    ],
                    lie1: [{ name: 'Outer Sendmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Outer Sendmsg' },
                    ],
                }
            },
            {
                path: '/home/database/externalUserAddress',
                component: () =>
                    import ("@/components/database/externalUserAddress.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '外部用户收信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '外部用户收信' },
                    ],
                    lie1: [{ name: 'Outer Rcvmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Outer Rcvmsg' },
                    ],
                }
            },
            {
                path: '/home/database/localSend',
                component: () =>
                    import ("@/components/database/localSend.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '本地域发信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '本地域发信' },
                    ],
                    lie1: [{ name: 'Local Domain Sendmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Local Domain Sendmsg' },
                    ],
                }
            },
            {
                path: '/home/database/localAddress',
                component: () =>
                    import ("@/components/database/localAddress.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '本地域收信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '本地域收信' },
                    ],
                    lie1: [{ name: 'Local Domain Rcvmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Local Domain Rcvmsg' },
                    ],
                }
            },
            {
                path: '/home/database/externalSend',
                component: () =>
                    import ("@/components/database/externalSend.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '外部域发信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '外部域发信' },
                    ],
                    lie1: [{ name: 'Out Domain Sendmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Out Domain Sendmsg' },
                    ],
                }
            },
            {
                path: '/home/database/externalAddress',
                component: () =>
                    import ("@/components/database/externalAddress.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '外部域收信' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '外部域收信' },
                    ],
                    lie1: [{ name: 'Out Domain Rcvmsg', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Out Domain Rcvmsg' },
                    ],
                }

            },
            {
                path: '/home/database/rankingIp',
                component: () =>
                    import ("@/components/database/rankingIp.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: 'IP排行' }],

                    name: [
                        { name: '邮件管理' },
                        { name: 'IP排行' },
                    ],
                    lie1: [{ name: 'Stat By IP', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Stat By IP' },
                    ],
                }

            },
            {
                path: '/home/database/rankingsIp',
                component: () =>
                    import ("@/components/database/rankingsIp.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: 'IP段排行' }],

                    name: [
                        { name: '邮件管理' },
                        { name: 'IP段排行' },
                    ],
                    lie1: [{ name: 'Stat By IP/24', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Stat By IP/24' },
                    ],
                }

            },
            {
                path: '/home/database/report',
                component: () =>
                    import ("@/components/database/report.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '报表及排程管理' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '报表及排程管理' },
                    ],
                    lie1: [{ name: 'Report Manager', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Report Manager' },
                    ],
                }

            },
            {
                path: '/home/database/ruleMatching',
                component: () =>
                    import ("@/components/database/ruleMatching.vue"),
                name: 'ruleMatching',

                meta: {
                    lie: [{ name: '规则匹配统计' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '规则匹配统计' },
                    ],
                    lie1: [{ name: 'Stat Of Rule Match', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Stat Of Rule Match' },
                    ],
                }

            },
            // 主题统计
            {
                path: '/home/database/theme',
                component: () =>
                    import ("@/components/database/theme.vue"),
                name: 'theme',

                meta: {
                    lie: [{ name: '主题统计' }],

                    name: [
                        { name: '邮件管理' },
                        { name: '主题统计' },
                    ],
                    lie1: [{ name: 'Topic of statistical', id: '2' }],
                    name1: [
                        { name: 'Email Management ' },
                        { name: 'Topic of statistical' },
                    ],
                }

            },
            // 安全管理 安全管理  Safety Control
            {
                path: '/home/config/basics',
                component: () =>
                    import ("@/components/config/basics.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '基础配置', id: '1' }],
                    lie1: [{ name: 'Gate Base Setting', id: '2' }],
                    name: [
                        { name: '系统配置' },
                        { name: '基础配置' },
                    ],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'Gate Base Setting' },
                    ],
                }

            },
            {
                path: '/home/config/gateway',
                component: () =>
                    import ("@/components/config/gateway.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '认证配置' }],
                    lie1: [{ name: 'Auth Setting', id: '2' }],
                    name: [
                        { name: '系统配置' },
                        { name: '认证配置' },
                    ],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'Auth Setting' },
                    ],
                }

            },
            {
                path: '/home/config/network',
                component: () =>
                    import ("@/components/config/network.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '网络配置' }],

                    name: [
                        { name: '系统配置' },
                        { name: '网络配置' },
                    ],
                    lie1: [{ name: 'Network Setting', id: '2' }],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'Network Setting' },
                    ],
                }


            },
            {
                path: '/home/config/firewall',
                component: () =>
                    import ("@/components/config/firewall.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '配置防火墙' }],

                    name: [
                        { name: '系统配置' },
                        { name: '配置防火墙' },
                    ],
                    lie1: [{ name: 'Iptables Setting', id: '2' }],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'Iptables Setting' },
                    ],
                }

            },
            {
                path: '/home/config/hotStandby',
                component: () =>
                    import ("@/components/config/hotStandby.vue"),
                name: 'cfg_auth',
                meta: {
                    lie: [{ name: '配置双机热备' }],

                    name: [
                        { name: '系统配置' },
                        { name: '配置双机热备' },
                    ],
                    lie1: [{ name: 'HA Setting', id: '2' }],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'HA Setting' },
                    ],
                }

            },
            {
                path: '/home/config/stystem',
                component: () =>
                    import ("@/components/config/stystem.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '系统服务' }],

                    name: [
                        { name: '系统配置' },
                        { name: '系统服务' },
                    ],
                    lie1: [{ name: 'System Service', id: '2' }],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'System Service' },
                    ],
                }
            },
            {
                path: '/home/config/patch',
                component: () =>
                    import ("@/components/config/patch.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '补丁升级' }],

                    name: [
                        { name: '系统配置' },
                        { name: '补丁升级' },
                    ],
                    lie1: [{ name: 'Patch Upgrade', id: '2' }],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'Patch Upgrade' },
                    ],
                }
            },
            {
                path: '/home/config/cluster',
                component: () =>
                    import ("@/components/config/cluster.vue"),
                name: 'cfg_auth',

                meta: {
                    lie: [{ name: '集群管理' }],

                    name: [
                        { name: '系统配置' },
                        { name: '集群管理' },
                    ],
                    lie1: [{ name: 'Colony Manage', id: '2' }],
                    name1: [
                        { name: 'System Layout' },
                        { name: 'Colony Manage' },
                    ],
                }

            },
            // 安全管理

            {
                path: '/home/antiSpam/basic',
                component: () =>
                    import ("@/components/antiSpam/basic.vue"),
                name: '555',

                meta: {
                    lie: [{ name: '基本参数' }],

                    name: [
                        { name: '安全管理' },
                        { name: '基本参数' },
                    ],
                    lie1: [{ name: 'Base Setting', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Base Setting' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/globalStrategy1',
                component: () =>
                    import ("@/components/antiSpam/globalStrategy1.vue"),
                name: '555',

                meta: {
                    lie: [{ name: '全局策略' }],

                    name: [
                        { name: '安全管理' },
                        { name: '全局策略' },
                    ],
                    lie1: [{ name: 'Policy Setting', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Policy Setting' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/filter',
                component: () =>
                    import ("@/components/antiSpam/filter.vue"),
                name: '555',

                meta: {
                    lie: [{ name: '过滤器' }],

                    name: [
                        { name: '安全管理' },
                        { name: '过滤器' },
                    ],
                    lie1: [{ name: 'Filter', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Filter' },
                    ],
                }
            },
            {
                path: '/home/antiSpam/filterStrategy',
                component: () =>
                    import ("@/components/antiSpam/filterStrategy.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '过滤策略' }],

                    name: [
                        { name: '安全管理' },
                        { name: '过滤策略' },
                    ],
                    lie1: [{ name: 'Policy List', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Policy List' },
                    ],
                }

            },
            // 模板管理
            {
                path: '/home/antiSpam/template_adm',
                component: () =>
                    import ("@/components/antiSpam/template_adm.vue"),
                name: 'template_adm',
                meta: {
                    lie: [{ name: '模板管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '过滤策略' },
                    ],
                    lie1: [{ name: 'template List', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'template List' },
                    ],
                }

            },
            // 策略组
            {
                path: '/home/antiSpam/strategy_group',
                component: () =>
                    import ("@/components/antiSpam/strategy_group.vue"),
                name: 'strategy_group',
                meta: {
                    lie: [{ name: '策略组' }],

                    name: [
                        { name: '安全管理' },
                        { name: '策略组' },
                    ],
                    lie1: [{ name: 'Strategy group', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Strategy group' },
                    ],
                }

            },
            // 区域权限
            {
                path: '/home/antiSpam/regional_authority',
                component: () =>
                    import ("@/components/antiSpam/regional_authority.vue"),
                name: 'regional_authority',
                meta: {
                    lie: [{ name: '区域管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '区域管理' },
                    ],
                    lie1: [{ name: 'Regional management', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Regional management' },
                    ],
                }

            },
            // // 策略权限
            // {
            //     path: '/home/antiSpam/regional_authority',
            //     component: () =>
            //         import ("@/components/antiSpam/regional_authority.vue"),
            //     name: 'regional_authority',
            //     meta: {
            //         lie: [{ name: '区域管理' }],

            //         name: [
            //             { name: '安全管理' },
            //             { name: '区域管理' },
            //         ],
            //         lie1: [{ name: 'Regional management', id: '2' }],
            //         name1: [
            //             { name: 'Safety Control' },
            //             { name: 'Regional management' },
            //         ],
            //     }

            // },
            // 区域分配
            {
                path: '/home/antiSpam/filterPower',
                component: () =>
                    import ("@/components/antiSpam/filterPower.vue"),
                name: 'filterPower',
                meta: {
                    lie: [{ name: '区域分配' }],

                    name: [
                        { name: '安全管理' },
                        { name: '区域分配' },
                    ],
                    lie1: [{ name: 'Area Distribution', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Area Distribution' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/allocation',
                component: () =>
                    import ("@/components/antiSpam/allocation.vue"),
                name: '555',
                meta: {
                    lie: [{ name: 'SPF配置' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'SPF配置' },
                    ],
                    lie1: [{ name: 'SPF Config', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'SPF Config' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/individuation',
                component: () =>
                    import ("@/components/antiSpam/individuation.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '个性化策略' }],

                    name: [
                        { name: '安全管理' },
                        { name: '个性化策略' },
                    ],
                    lie1: [{ name: 'Personalized Settings', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Personalized Settings' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/control',
                component: () =>
                    import ("@/components/antiSpam/control.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '系统收发控制' }],

                    name: [
                        { name: '安全管理' },
                        { name: '系统收发控制' },
                    ],
                    lie1: [{ name: 'System Transceiver Control', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'System Transceiver Control' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/recipientCheck',
                component: () =>
                    import ("@/components/antiSpam/recipientCheck.vue"),
                name: '555',
                meta: {
                    lie: [{ name: 'LDAP和收件人检查' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'LDAP和收件人检查' },
                    ],
                    lie1: [{ name: 'Rcpt Check', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Rcpt Check' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/abnormal',
                component: () =>
                    import ("@/components/antiSpam/abnormal.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '异常及滥发管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '异常及滥发管理' },
                    ],
                    lie1: [{ name: 'Abnormal And Abuse', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Abnormal And Abuse' },
                    ],
                }

            },
            // 发信ip 管控
            {
                path: '/home/antiSpam/sendIp',
                component: () =>
                    import ("@/components/antiSpam/sendIp.vue"),
                name: 'sendIp',
                meta: {
                    lie: [{ name: 'SMTP发信IP管控' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'SMTP发信IP管控' },
                    ],
                    lie1: [{ name: 'IP Control By Smtp', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'IP Control By Smtp' },
                    ],
                }

            },
            // SMTP免认证IP范围
            {
                path: '/home/antiSpam/free_Ip',
                component: () =>
                    import ("@/components/antiSpam/free_Ip.vue"),
                name: 'free_Ip',
                meta: {
                    lie: [{ name: 'SMTP免认证IP范围' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'SMTP免认证IP范围' },
                    ],
                    lie1: [{ name: 'IP Free By Smtp', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'IP Free By Smtp' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/blacklist',
                component: () =>
                    import ("@/components/antiSpam/blacklist.vue"),
                name: '555',
                meta: {
                    lie: [{ name: 'IP黑名单认证管控' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'IP黑名单认证管控' },
                    ],
                    lie1: [{ name: 'IP Black Auth Control', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'IP Black Auth Control' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/smartLearn',
                component: () =>
                    import ("@/components/antiSpam/smartLearn.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '智能学习管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '智能学习管理' },
                    ],
                    lie1: [{ name: 'Smart Learning', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Smart Learning' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/snmp_manage',
                component: () =>
                    import ("@/components/antiSpam/snmp_manage.vue"),
                name: 'snmp_manage',
                meta: {
                    lie: [{ name: 'SNMP管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'SNMP管理' },
                    ],
                    lie1: [{ name: 'SNMP Manage', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'SNMP Manage' },
                    ],
                }

            },
            // 免责声明
            {
                path: '/home/antiSpam/disclaimer',
                component: () =>
                    import ("@/components/antiSpam/disclaimer.vue"),
                name: 'disclaimer',
                meta: {
                    lie: [{ name: '免责声明' }],

                    name: [
                        { name: '安全管理' },
                        { name: '免责声明' },
                    ],
                    lie1: [{ name: 'Disclaimer', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Disclaimer' },
                    ],
                }

            },
            // 免责声明新
            {
                path: '/home/antiSpam/disclaimer_new',
                component: () =>
                    import ("@/components/antiSpam/disclaimer_new.vue"),
                name: 'disclaimer_new',
                meta: {
                    lie: [{ name: '免责声明' }],

                    name: [
                        { name: '安全管理' },
                        { name: '免责声明' },
                    ],
                    lie1: [{ name: 'Disclaimer', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Disclaimer' },
                    ],
                }

            },
            // 风险提示
            {
                path: '/home/antiSpam/prompt_statement',
                component: () =>
                    import ("@/components/antiSpam/prompt_statement.vue"),
                name: 'prompt_statement',
                meta: {
                    lie: [{ name: '风险提示' }],

                    name: [
                        { name: '安全管理' },
                        { name: '风险提示' },
                    ],
                    lie1: [{ name: 'Risk Warning', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Risk Warning' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/accessory',
                component: () =>
                    import ("@/components/antiSpam/accessory.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '附件解析管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '附件解析管理' },
                    ],
                    lie1: [{ name: 'Attach Resolution', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Attach Resolution' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/greyList',
                component: () =>
                    import ("@/components/antiSpam/greyList.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '灰名单管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '灰名单管理' },
                    ],
                    lie1: [{ name: 'Grey List', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Grey List' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/dkim',
                component: () =>
                    import ("@/components/antiSpam/dkim.vue"),
                name: '555',
                meta: {
                    lie: [{ name: 'DKIM And DMARC' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'DKIM And DMARC' },
                    ],
                    lie1: [{ name: 'DKIM And DMARC', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'DKIM And DMARC' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/scan',
                component: () =>
                    import ("@/components/antiSpam/scan.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '沙箱扫描管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '沙箱扫描管理' },
                    ],
                    lie1: [{ name: 'Sandbox Config', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Sandbox Config' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/snmp',
                component: () =>
                    import ("@/components/antiSpam/snmp.vue"),
                name: '555',
                meta: {
                    lie: [{ name: 'SNMP管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'SNMP管理' },
                    ],
                    lie1: [{ name: 'Snmp Config', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Snmp Config' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/agency',
                component: () =>
                    import ("@/components/antiSpam/agency.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '代理管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: '代理管理' },
                    ],
                    lie1: [{ name: 'Proxy Config', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Proxy Config' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/tls_policy',
                component: () =>
                    import ("@/components/antiSpam/tls_policy.vue"),
                name: 'tls_policy',
                meta: {
                    lie: [{ name: 'TLS策略管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'TLS策略管理' },
                    ],
                    lie1: [{ name: 'TLS_policy manage', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'TLS_policy manage' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/url_list',
                component: () =>
                    import ("@/components/antiSpam/url_list.vue"),
                name: '555',
                meta: {
                    lie: [{ name: 'URL隔离管理' }],

                    name: [
                        { name: '安全管理' },
                        { name: 'URL隔离管理' },
                    ],
                    lie1: [{ name: 'URL Isolation', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'URL Isolation' },
                    ],
                }

            },
            {
                path: '/home/antiSpam/dark',
                component: () =>
                    import ("@/components/antiSpam/dark.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '暗送设置' }],

                    name: [
                        { name: '安全管理' },
                        { name: '暗送设置' },
                    ],
                    lie1: [{ name: 'Set Bcc', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Set Bcc' },
                    ],
                }

            },
            // 策略组配置 Ranking Strategy
            {
                path: '/home/strategy/group',
                component: () =>
                    import ("@/components/strategy/group.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '组级策略' }],

                    name: [
                        { name: '分级策略' },
                        { name: '组级策略' },
                    ],
                    lie1: [{ name: 'Group Policy', id: '2' }],
                    name1: [
                        { name: 'Ranking Strategy' },
                        { name: 'Group Policy' },
                    ],
                }

            },
            {
                path: '/home/strategy/domain',
                component: () =>
                    import ("@/components/strategy/domain.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '域级策略' }],

                    name: [
                        { name: '分级策略' },
                        { name: '域级策略' },
                    ],
                    lie1: [{ name: 'Domain Policy', id: '2' }],
                    name1: [
                        { name: 'Ranking Strategy' },
                        { name: 'Domain Policy' },
                    ],
                }

            },
            // 白名单列表
            {
                path: '/home/white_list',
                component: () =>
                    import ("@/components/white_list.vue"),
                name: 'white_list',
                meta: {
                    lie: [{ name: '白名单列表' }],

                    name: [
                        { name: '白名单列表' },
                        { name: '白名单列表' },
                    ],
                    lie1: [{ name: 'white_list', id: '2' }],
                    name1: [
                        { name: 'White List' },
                        { name: 'white_list' },
                    ],
                }

            },
            {
                path: '/home/user_strategy/bw_list',
                component: () =>
                    import ("@/components/user_strategy/bw_list.vue"),
                name: 'bw_list',
                meta: {
                    lie: [{ name: '黑白名单' }],

                    name: [
                        { name: '用户策略' },
                        { name: '黑白名单' },
                    ],
                    lie1: [{ name: 'bw_list', id: '2' }],
                    name1: [
                        { name: 'User_strategy' },
                        { name: 'bw_list' },
                    ],
                }

            },
            {
                path: '/home/strategy/userLevel',
                component: () =>
                    import ("@/components/strategy/userLevel.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '用户级策略' }],

                    name: [
                        { name: '分级策略' },
                        { name: '用户级策略' },
                    ],
                    lie1: [{ name: 'Email Policy', id: '2' }],
                    name1: [
                        { name: 'Ranking Strategy' },
                        { name: 'Email Policy' },
                    ],
                }

            },
            {
                path: '/home/strategy/priority',
                component: () =>
                    import ("@/components/strategy/priority.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '策略优先级' }],

                    name: [
                        { name: '分级策略' },
                        { name: '策略优先级' },
                    ],
                    lie1: [{ name: 'Policy Order', id: '2' }],
                    name1: [
                        { name: 'Ranking Strategy' },
                        { name: 'Policy Order' },
                    ],
                }

            },
            // 垃圾病毒隔离列表
            // 精查
            {
                path: '/home/garbageVirus/listOne/:rec_id',
                component: () =>
                    import ("@/components/garbageVirus/listOne.vue"),
                name: 'listOne1',
                meta: {
                    keepAlive: false,

                }

            },
            // 不是elk
            {
                path: '/home/garbageVirus/listOne1/:rec_id',
                component: () =>
                    import ("@/components/garbageVirus/listOne1.vue"),
                name: 'listOne',
                meta: {
                    keepAlive: false, // 不需要缓存

                }

            },
            {
                path: '/home/garbageVirus/wasteInsulate1',
                component: () =>
                    import ("@/components/garbageVirus/wasteInsulate1.vue"),
                name: 'wasteInsulate1',

                meta: {
                    lie: [{ name: '精查隔离列表' }],

                    name: [
                        { name: '隔离邮件' },
                        { name: '精查隔离列表' },
                    ],
                    lie1: [{ name: 'Sifting List', id: '2' }],
                    name1: [
                        { name: 'Separate Email' },
                        { name: 'Sifting List' },
                    ],
                }


            },
            // meta: {
            //     lie: [{ name: '精查非正常列表' }],

            //     name: [
            //         { name: '非正常邮件' },
            //         { name: '精查非正常列表' },
            //     ],
            //     lie1: [{ name: 'ElkAbnormal List', id: '2' }],
            //     name1: [
            //         { name: 'Abnormal Mail' },
            //         { name: 'ElkAbnormal List' },
            //     ],
            // }

            {
                path: '/home/garbageVirus/wasteInsulate',
                component: () =>
                    import ("@/components/garbageVirus/wasteInsulate.vue"),
                name: 'wasteInsulate',

                meta: {
                    lie: [{ name: '隔离邮件列表' }],

                    name: [
                        { name: '隔离邮件' },
                        { name: '隔离邮件列表' },
                    ],
                    lie1: [{ name: 'Quarantine list', id: '2' }],
                    name1: [
                        { name: 'Separate Email' },
                        { name: 'Quarantine list' },
                    ],
                }
            },
            {
                path: '/home/garbageVirus/wasteInsulate_region',
                component: () =>
                    import ("@/components/garbageVirus/wasteInsulate_region.vue"),
                name: 'wasteInsulate_region',

                meta: {
                    lie: [{ name: '区域所有邮件' }],

                    name: [
                        { name: '隔离邮件' },
                        { name: '区域所有邮件' },
                    ],
                    lie1: [{ name: 'Mail Region', id: '2' }],
                    name1: [
                        { name: 'Separate Email' },
                        { name: 'Mail Region' },
                    ],
                }


            },
            {
                path: '/home/garbageVirus/custom_insulate',
                component: () =>
                    import ("@/components/garbageVirus/custom_insulate.vue"),
                name: 'custom_insulate',

                meta: {
                    lie: [{ name: '区域隔离邮件' }],

                    name: [
                        { name: '隔离邮件' },
                        { name: '区域隔离邮件' },
                    ],
                    lie1: [{ name: 'Regional Isolation List', id: '2' }],
                    name1: [
                        { name: 'Separate Email' },
                        { name: 'Regional Isolation List' },
                    ],
                }
            },
            {
                path: '/home/garbageVirus/released',
                component: () =>
                    import ("@/components/garbageVirus/released.vue"),
                name: '555',


            },
            {
                path: '/home/garbageVirus/virusInsulate',
                component: () =>
                    import ("@/components/garbageVirus/virusInsulate.vue"),
                name: '555',


            },
            {
                path: '/home/garbageVirus/outsource',
                component: () =>
                    import ("@/components/garbageVirus/outsource.vue"),
                name: '555',

            },
            {
                path: '/home/garbageVirus/account',
                component: () =>
                    import ("@/components/garbageVirus/account.vue"),
                name: '555',


            },
            {
                path: '/home/garbageVirus/combination',
                component: () =>
                    import ("@/components/garbageVirus/combination.vue"),
                name: '555',


            },
            {
                path: '/home/garbageVirus/insulate',
                component: () =>
                    import ("@/components/garbageVirus/insulate.vue"),
                name: 'insulate',
                meta: {
                    lie: [{ name: '隔离通知管理' }],

                    name: [
                        { name: '隔离邮件' },
                        { name: '隔离通知管理' },
                    ],
                    lie1: [{ name: 'Notify Manage', id: '2' }],
                    name1: [
                        { name: 'Separate Email' },
                        { name: 'Notify Manage' },
                    ],
                }

            },
            // 审核区管理
            {
                path: '/home/audit/auditStrategy',
                component: () =>
                    import ("@/components/audit/auditStrategy.vue"),
                name: '555',
                meta: {
                    lie: [{ name: '审核策略' }],

                    name: [
                        { name: '审核区管理' },
                        { name: '审核策略' },
                    ],
                    lie1: [{ name: 'Audit Policy', id: '2' }],
                    name1: [
                        { name: 'Audit Manage' },
                        { name: 'Audit Policy' },
                    ],
                }

            },
            // 不是elk
            {
                path: '/home/audit/listOne/:rec_id',
                component: () =>
                    import ("@/components/audit/listOne.vue"),
                name: 'auditMailOne',


            },
            {
                path: '/home/audit/auditMail',
                component: () =>
                    import ("@/components/audit/auditMail.vue"),
                name: 'auditMail',
                meta: {
                    lie: [{ name: '审核区邮件' }],

                    name: [
                        { name: '审核区管理' },
                        { name: '审核区邮件' },
                    ],
                    lie1: [{ name: 'Audit List', id: '2' }],
                    name1: [
                        { name: 'Audit Manage' },
                        { name: 'Audit List' },
                    ],
                }

            },
            {
                path: '/home/audit/auditAccount',
                component: () =>
                    import ("@/components/audit/auditAccount.vue"),
                name: '555',


            },
            {
                path: '/home/audit/auditCombination',
                component: () =>
                    import ("@/components/audit/auditCombination.vue"),
                name: '555',


            },
            // 不是elk
            {
                path: '/home/deferSend/listOne1/:rec_id',
                component: () =>
                    import ("@/components/deferSend/listOne.vue"),
                name: 'deferlistOne',


            },
            // 延迟投递区
            {
                path: '/home/deferSend/list',
                component: () =>
                    import ("@/components/deferSend/list.vue"),
                name: 'deferSend_list',
                meta: {
                    lie: [{ name: '延迟投递列表' }],

                    name: [
                        { name: '延迟投递区' },
                        { name: '延迟投递列表' },
                    ],
                    lie1: [{ name: 'Defer List', id: '2' }],
                    name1: [
                        { name: 'Defer Send Manage' },
                        { name: 'Defer List' },
                    ],
                }

            },
            {
                path: '/home/deferSend/query',
                component: () =>
                    import ("@/components/deferSend/query.vue"),
                name: '555',


            },













            {
                path: '/home/antiSpam/globalStrategy2',
                component: () =>
                    import ("@/components/antiSpam/globalStrategy2.vue"),
                name: '555',
                meta: [
                    { name: '安全管理' },
                    { name: '全局策略' },
                ],

            },
            {
                path: '/home/antiSpam/combinedStrategy',
                component: () =>
                    import ("@/components/antiSpam/combinedStrategy.vue"),
                name: '555',

                meta: {
                    lie: [{ name: '组合策略' }],

                    name: [
                        { name: '安全管理' },
                        { name: '组合策略' },
                    ],
                    lie1: [{ name: 'Combined Policy', id: '2' }],
                    name1: [
                        { name: 'Safety Control' },
                        { name: 'Combined Policy' },
                    ],
                }
            },
            {
                path: '/home/antiSpam/globalStrategy',
                component: () =>
                    import ("@/components/antiSpam/globalStrategy.vue"),
                name: 'a',

                children: [{
                        path: '/home/antiSpam/globalStrategy/1',
                        component: () =>
                            import ("@/components/antiSpam/sanji/guolv.vue"),
                        name: '555',


                    },
                    {
                        path: '/home/antiSpam/globalStrategy/2',
                        component: () =>
                            import ("@/components/antiSpam/sanji/guolv1.vue"),
                        name: '555',


                    },
                ],
                meta: [
                    { name: '安全管理' },
                    { name: '组合策略' },
                ],

            },

        ],


    },

    // 默认
    {
        path: '/',
        redirect: '/login'
    },
    {
        path: '*',
        component: error,


    },



];
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);
const router = new VueRouter({
    routes,
});



export default router;